import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { TiposUnidadDTO } from "src/app/models/tipo-unidad.dto";

@Component({
  selector: "app-form-unidades",
  templateUrl: "./form.component.html",
})
export class TiposUnidadForm extends CrudForm<TiposUnidadDTO> {
  public fromInit(row: TiposUnidadDTO) {
    this.form.controls["IdTipoUnidad"].setValue(row?.IdTipoUnidad);
    this.form.controls["Descripcion"].patchValue(row?.Descripcion);
  }

  protected buildForm() {
    this.form = this.fb.group({
      IdTipoUnidad: [""],
      Descripcion: [""],
    });
  }
}
